"use client";
import { ReactNode, MouseEvent } from 'react';
import { dataLayer } from '@repo/analytics/data-layer-utils'; 
import { componentNameConstants, dlElementConstants, dlEventConstants, dlCtaTextConstants } from '@repo/analytics/data-layer.constants';
import { useRouter } from 'next/navigation';
import { handleRedirection } from '../../utils/helper';
interface AnalyticsBannerLinkProps {
  target: string;
  className?: string;
  linkUrl: string; 
  children: ReactNode;
  bannerData: {
    ctaText?: string;
    altCtaText?: string;
    sectionTitle?: string;
    index: number;
    moduleName: string;
    sectionName: string;
    totalBanners: number;
  };
}

const AnalyticsBannerLink: React.FC<AnalyticsBannerLinkProps> = ({
  target,
  className,
  children,
  linkUrl,
  bannerData
}) => {
  const router = useRouter();
  const handleClick = (e: MouseEvent<HTMLDivElement>) => {  
    const isNewTab = target === "_blank"; 
    handleRedirection(linkUrl, router, `${isNewTab}`); 
    const bannerCarouselDl = {
      component: componentNameConstants.BANNER_CAROUSEL,
      cta_text: bannerData.ctaText || bannerData.altCtaText,
      element: dlEventConstants.BANNER_CLICK,
      destination_url: linkUrl,
      event: dlEventConstants.CLICK,
      event_type: dlElementConstants.BANNER_CAROUSEL_CTA,
      section_title: bannerData.sectionTitle,
      tab_position: (bannerData.index + 1).toString(),
    };

    const cleverTapObj = {
      EP_BANNER_MODULE_NAME: bannerData.moduleName,
      EP_BANNER_MODULE_SECTION: bannerData.sectionName,
      EP_BANNER_DISPLAY_COUNT: bannerData.totalBanners.toString(),
      isBannerComponent: "true",
    };

    dataLayer("",bannerCarouselDl, cleverTapObj);
  };

  return (
    <div
      role = "button"
      className={className}
      onClick={handleClick}
      >
      {children}
      </div>
  );
};

export default AnalyticsBannerLink;